import { Component, Input, OnInit } from '@angular/core';
import { MessagesEnum } from 'src/app/enums/messages.enum';
@Component({
  selector: 'app-itinerary-details',
  templateUrl: './itinerary-details.component.html',
  styleUrls: ['./itinerary-details.component.css']
})
export class ItineraryDetailsComponent implements OnInit {

  @Input() public itineraries: any[];
  @Input() public className: string;
  @Input() public isIncludeTableHeader = false;
  @Input() public tourLengthShortName: string;
  @Input() public cruiseName: string;
  @Input() public itineraryDescription: string = '';
  itineraryDisclaimer = MessagesEnum.ITINERARY_DISCLAIMER;

  constructor() {}

  ngOnInit() {}
  isPair(index: number) {
    return index % 2 === 0 ? true : false;
  }

  addStyleToDescription(description: string): string {
    let desc = description.replace("<ul>", "<ul class='custom-ul'>").split("<li>").join("<li class='custom-li'>");
    return desc;
  }

}
